module.exports = __webpack_public_path__ + "img/left-1.652427d5.png";